<template>
	<div class="projects">
		<Project v-for="project in projects"
		         :project="project" />
	</div>
</template>
<script>
import Project from '@/components/Project.vue';
import projects from '@/data/projects.js';

export default {
	components: {
		Project
	},
	data: () => ({
		projects
	})
}
</script>
<style lang="scss">
.projects {
	display: flex;
	flex-direction: column;
	justify-content: center;
}
</style>